import { MenuContain } from '../../../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuContain';
import { JointMenuSetShape } from '../Shape/JointMenuSetShape';
import { RelationshipLink } from '../../BaseShape/RelationshipLink';
import { MDAConstant } from '../../Base/MDAConstant';
import { MDRepository } from '../../../MD/MDRepository';

export class JointMenuContainLink extends RelationshipLink {
  constructor(opt?: any) {
    super(opt);
    this.set('type', 'mst.JointMenuContainLink');
    this.attr({
      line: {
        stroke: 'lime', // 绿色
        targetMarker: { fill: 'none', d: 'M 10 -5 L 0 0 L 10 5 L 0 0 z' },
        sourceMarker: { fill: 'lime', d: 'M 20 0 L 10 5 L 0 0 L 10 -5 z' }
      }
    });
    // 反序列化调用，手工创建的时候不调用
    if (opt) {
      this.setMD(opt?.shape, opt?.model, true);
    }
  }

  changeTarget(source: joint.dia.Element, target: joint.dia.Element) {
    if (target instanceof JointMenuSetShape && source instanceof JointMenuSetShape) {
      const sourceMenuSet = source.menuSet;
      const targetMenuSet = target.menuSet;
      let relationship = this.element() as MenuContain;
      if (relationship === null) {
        relationship = MDRepository.createMenuContain(null, sourceMenuSet, targetMenuSet, false);
      }
      relationship.name = `${sourceMenuSet.name}_Contain_${targetMenuSet.name}`;
      relationship.displayName = `${sourceMenuSet.displayName}_包含_${targetMenuSet.displayName}`;
      relationship.description = relationship.displayName;
      relationship.subMenuSet = targetMenuSet;
      this.setModel(relationship);
      sourceMenuSet.mainMenuContains.push(relationship);
      targetMenuSet.subMenuContains.push(relationship);
      return relationship;
    }
    return null;
  }

  get menuContain(): MenuContain {
    return this.element() as MenuContain;
  }

  public shapeType(): string {
    return MDAConstant.Link.ADD_MENUCONTAIN;
  }

  /**
   * 检查源和目标类型对当前关系是否有效
   * 主子菜单关系：仅用于菜单集与菜单集
   * @param sourceType 源类型
   * @param targetType 目标类型
   * @returns 有效返回true
   */
  public checkShapeType(sourceType: string, targetType: string): boolean {
    if (sourceType === MDAConstant.Type.ADD_MENUSET && targetType === MDAConstant.Type.ADD_MENUSET) {
      return true;
    }
    return false;
  }
}
